import { GenerateOptions } from "../../smartSchedule/smartScheduleUtils";
import previewSchedulePageStore from "../store/store";
import { mutatorAction } from "satcheljs";

// Mutators that controls display state of UI
export const setIsPreviewSchedulePageOpen = mutatorAction("setIsPreviewSchedulePageOpen", (isOpen: boolean) => {
   previewSchedulePageStore().isPageOpen = isOpen;
});

export const setSelectedTagId = mutatorAction("setSelectedTagId", (tagId: string) => {
   previewSchedulePageStore().selectedTagId = tagId;
});

export const setStartAndEndDate = mutatorAction("setStartAndEndDate", (startDate: string, endDate: string) => {
   previewSchedulePageStore().startDate = startDate;
   previewSchedulePageStore().endDate = endDate;
});

export const setSelectedJobId = mutatorAction("setSelectedJobId", (jobId: string) => {
   previewSchedulePageStore().jobId = jobId;
});

export const setupPreviewSchedulePageStates = mutatorAction("setupPreviewSchedulePageStates", (isViewStatePopulated: boolean) => {
   previewSchedulePageStore().isViewStatePopulated = isViewStatePopulated;
});

export const setGenerateOption = mutatorAction("setGenerateOption", (generateOption: GenerateOptions) => {
    previewSchedulePageStore().generateOption = generateOption;
});
